import { z } from "zod";
import { SearchResultProps } from "~/components/molecules/search-bar";
import {
  autocompleteSchema,
  AutocompleteType,
} from "~/schemas/apis/autocomplete";
import { tryCatch } from "./try-catch";

export async function fetchAutocomplete(search: string, country: string) {
  const result = await tryCatch(
    fetch(`/api/location/autocomplete?query=${search}&country=${country}`)
  );

  if (result.error) {
    console.error("Error fetching charge point details:", result.error);
    throw result.error;
  }

  return result.data.json();
}

export function formatAutocompleteData(data: unknown): SearchResultProps[] {
  const parsedData = z.array(autocompleteSchema).parse(data);

  if (!parsedData) throw new Error("Error parsing data");

  return parsedData.map((item: AutocompleteType) => ({
    id: item.id,
    summaryline: item.summaryline,
    label: `${item.summaryline} ${item.locationsummary}`,
  }));
}
